module.exports = "<button mat-button>Next</button>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/utils/buttonstep/buttonstep.component.html
// module id = ../../../../../src/app/components/utils/buttonstep/buttonstep.component.html
// module chunks = main